export default{goOffline:'Go Offline',goOnline:'Go Online'};